export const BalanceBucketOptions = {
  1: '<$0',
  2: '$0-$99',
  3: '$100-$499',
  4: '$500-$999',
  5: '$1,000-$4,999',
  6: '$5,000-$9,999',
  7: '$10,000-$24,999',
  8: '$25,000-$49,999',
  9: '$50,000-$99,999',
  10: '>$100,000',
};

export const BalanceBucketDropdownOptions = Object.entries(
  BalanceBucketOptions
).map(([id, value]) => ({
  id: parseInt(id),
  balanceBucket: value,
}));

export const arDetailHeaders = [
  {
    key: 'mrn',
    value: 'MRN',
    sort: true,
    minWidth: 'min-w-40',
    format: 'string',
  },
  {
    key: 'account_number',
    value: 'Account Number',
    sort: true,
    minWidth: 'min-w-40',
    format: 'string',
  },
  {
    key: 'visit_number',
    value: 'Visit Number',
    sort: true,
    minWidth: 'min-w-40',
  },

  {
    key: 'claim_number',
    value: 'Claim Number',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'current_balance',
    value: 'Current Balance',
    format: 'currency',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'balance_bucket',
    value: 'Balance Bucket',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'total_charges',
    value: 'Total Charges',
    sort: true,
    format: 'currency',
    minWidth: 'min-w-40',
  },
  {
    key: 'total_payments',
    value: 'Total Payments',
    sort: true,
    format: 'currency',
    minWidth: 'min-w-40',
  },
  {
    key: 'total_adjustments',
    value: 'Total Adjustments',
    sort: true,
    format: 'currency',
    minWidth: 'min-w-48',
  },
  {
    key: 'current_financial_class_name',
    value: 'Current Financial Class',
    sort: true,
    minWidth: 'min-w-64',
  },
  {
    key: 'current_payer_name',
    value: 'Current Payer',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'current_plan_name',
    value: 'Current Plan',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'primary_financial_class_name',
    value: 'Primary Financial Class',
    sort: true,
    minWidth: 'min-w-64',
  },
  {
    key: 'primary_payer_name',
    value: 'Primary Payer',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'primary_plan_name',
    value: 'Primary Plan',
    sort: true,
    minWidth: 'min-w-40',
  },
  { key: 'phase', value: 'Phase', sort: true, minWidth: 'min-w-32' },
  { key: 'status', value: 'Status', sort: true, minWidth: 'min-w-32' },
  { key: 'reason', value: 'Reason', sort: true, minWidth: 'min-w-32' },
  { key: 'score', value: 'Score', sort: true, minWidth: 'min-w-32' },
  {
    key: 'billing_type',
    value: 'Billing Type',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'billing_entity',
    value: 'Billing Entity',
    sort: true,
    minWidth: 'min-w-40',
  },
  { key: 'visit_type', value: 'Visit Type', sort: true, minWidth: 'min-w-40' },
  { key: 'location', value: 'Location Name', sort: true },
  {
    key: 'department',
    value: 'Department Name',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'billing_provider',
    value: 'Billing Provider Name',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'billing_provider_npi',
    value: 'Billing Provider NPI',
    format: 'string',
    sort: true,
    minWidth: 'min-w-48',
  },
  {
    key: 'dx_one_id',
    value: 'Diagnosis Code',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'service_start_date',
    value: 'Service Start Date',
    format: 'date',
    sort: true,
    minWidth: 'min-w-48',
  },
  {
    key: 'service_end_date',
    value: 'Service End Date',
    width: '12rem',
    format: 'date',
    sort: true,
    minWidth: 'min-w-48',
  },
  {
    key: 'age_category',
    value: 'Age Category',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'appeal_deadline',
    value: 'Appeal Deadline',
    format: 'date',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'assigned_worklist',
    value: 'Assigned Worklist',
    sort: true,
    minWidth: 'min-w-48',
  },
  {
    key: 'last_denial_date',
    value: 'Last Denial Date',
    format: 'date',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'last_payment_date',
    value: 'Last Payment Date',
    format: 'date',
    sort: true,
    minWidth: 'min-w-48',
  },
  {
    key: 'last_claim_date',
    value: 'Last Claim Date',
    format: 'date',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'last_activity_date',
    value: 'Last Activity Date',
    format: 'date',
    sort: true,
    minWidth: 'min-w-48',
  },
  {
    key: 'last_activity_user',
    value: 'Last Activity User',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'last_activity_type',
    value: 'Last Activity Type',
    sort: true,
    minWidth: 'min-w-48',
  },
  {
    key: 'last_activity_subtype',
    value: 'Last Activity Subtype',
    sort: true,
    minWidth: 'min-w-48',
  },
  {
    key: 'last_activity_note',
    value: 'Last Note',
    sort: true,
    minWidth: 'min-w-40',
  },
];

export const splitByOptions = [
  {
    id: 'none',
    text: 'None',
  },
  {
    id: 'billingProvider',
    text: 'Billing Provider',
  },
  {
    id: 'billingEntity',
    text: 'Billing Entity',
  },
  {
    id: 'user',
    text: 'User',
  },
  {
    id: 'location',
    text: 'Location',
  },
  {
    id: 'department',
    text: 'Department',
  },
  {
    id: 'financialClass',
    text: 'Current Financial Class',
  },
  {
    id: 'payer',
    text: 'Current Payer',
  },
  {
    id: 'plan',
    text: 'Current Plan',
  },
  {
    id: 'phase',
    text: 'Phase',
  },
  {
    id: 'status',
    text: 'Status',
  },
  {
    id: 'reason',
    text: 'Reason',
  },
  {
    id: 'balanceBucket',
    text: 'Balance Bucket',
  },
  {
    id: 'ageCategory',
    text: 'Age Category',
  },
  {
    id: 'activityType',
    text: 'Activity',
  },
  {
    id: 'activitySubtype',
    text: 'Activity Subtype',
  },
];

export const arHighDollarHeaders = [
  { key: 'status', value: 'Status', sort: false },
  { key: 'mrn', value: 'MRN', sort: true, minWidth: 'min-w-40' },
  {
    key: 'account_number',
    value: 'Account Number',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'visit_number',
    value: 'Visit Number',
    sort: true,
    minWidth: 'min-w-40',
  },

  {
    key: 'claim_number',
    value: 'Claim Number',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'current_balance',
    value: 'Current Balance',
    format: 'currency',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'balance_bucket',
    value: 'Balance Bucket',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'total_charges',
    value: 'Total Charges',
    format: 'currency',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'total_payments',
    value: 'Total Payments',
    format: 'currency',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'total_adjustments',
    value: 'Total Adjustments',
    format: 'currency',
    sort: true,
    minWidth: 'min-w-48',
  },
  {
    key: 'current_financial_class_name',
    value: 'Current Financial Class',
    sort: true,
    minWidth: 'min-w-64',
  },
  {
    key: 'current_payer_name',
    value: 'Current Payer',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'current_plan_name',
    value: 'Current Plan',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'primary_financial_class_name',
    value: 'Primary Financial Class',
    sort: true,
    minWidth: 'min-w-64',
  },
  {
    key: 'primary_payer_name',
    value: 'Primary Payer',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'primary_plan_name',
    value: 'Primary Plan',
    sort: true,
    minWidth: 'min-w-40',
  },
  { key: 'phase', value: 'Phase', sort: true, minWidth: 'min-w-32' },
  { key: 'original_status', value: 'Status', sort: true, minWidth: 'min-w-32' },
  { key: 'reason', value: 'Reason', sort: true, minWidth: 'min-w-32' },
  { key: 'score', value: 'Score', sort: true, minWidth: 'min-w-32' },
  {
    key: 'billing_type',
    value: 'Billing Type',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'billing_entity',
    value: 'Billing Entity',
    sort: true,
    minWidth: 'min-w-40',
  },
  { key: 'visit_type', value: 'Visit Type', sort: true, minWidth: 'min-w-40' },
  { key: 'location', value: 'Location Name', sort: true },
  {
    key: 'department',
    value: 'Department Name',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'billing_provider',
    value: 'Billing Provider Name',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'billing_provider_npi',
    value: 'Billing Provider NPI',
    sort: true,
    minWidth: 'min-w-48',
  },
  {
    key: 'dx_one_id',
    value: 'Diagnosis Code',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'service_start_date',
    value: 'Service Start Date',
    sort: true,
    format: 'date',
    minWidth: 'min-w-48',
  },
  {
    key: 'service_end_date',
    value: 'Service End Date',
    width: '12rem',
    format: 'date',
    sort: true,
    minWidth: 'min-w-48',
  },
  {
    key: 'age_category',
    value: 'Age Category',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'appeal_deadline',
    value: 'Appeal Deadline',
    format: 'date',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'assigned_worklist',
    value: 'Assigned Worklist',
    sort: true,
    minWidth: 'min-w-48',
  },
  {
    key: 'last_denial_date',
    value: 'Last Denial Date',
    format: 'date',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'last_payment_date',
    value: 'Last Payment Date',
    format: 'date',
    sort: true,
    minWidth: 'min-w-48',
  },
  {
    key: 'last_claim_date',
    value: 'Last Claim Date',
    format: 'date',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'last_activity_date',
    value: 'Last Activity Date',
    format: 'date',
    sort: true,
    minWidth: 'min-w-48',
  },
  {
    key: 'last_activity_user',
    value: 'Last Activity User',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'last_activity_type',
    value: 'Last Activity Type',
    sort: true,
    minWidth: 'min-w-48',
  },
  {
    key: 'last_activity_subtype',
    value: 'Last Activity Subtype',
    sort: true,
    minWidth: 'min-w-48',
  },
  {
    key: 'last_activity_note',
    value: 'Last Note',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'cdf_1',
    value: 'CDF 1',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'cdf_2',
    value: 'CDF 2',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'cdf_3',
    value: 'CDF 3',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'cdf_4',
    value: 'CDF 4',
    sort: true,
    minWidth: 'min-w-40',
  },
  {
    key: 'cdf_5',
    value: 'CDF 5',
    sort: true,
    minWidth: 'min-w-40',
  },
];
